import React from "react";
import PropTypes from "prop-types";
import {useTranslation} from "@unibuddy/intl";
import s from "./AccountLocked.pcss";
import PageHeader from "../../../Shared/components/PageHeader/PageHeader";
import {IntlNamespaces} from "../../../../translations/types";
import {
    INTL_ACCOUNT_LOCKED,
    INTL_ACCOUNT_LOCKED_MESSAGE,
    INTL_REQUEST_NEW_EMAIL,
    INTL_UNLOCK_INSTRUCTIONS,
} from "../../../../translations/accountLocked";

const AccountLocked = (props) => {
    const {t} = useTranslation(IntlNamespaces.ACCOUNT_LOCKED);

    return (
        <div className={s.container} id="accountLocked">
            <div className={s.header}>
                <p className={s.icons}>
                    <i className="fa fa-lock" aria-hidden="true" />
                </p>
                <PageHeader
                    className={s.heading}
                    title={t(INTL_ACCOUNT_LOCKED.key, INTL_ACCOUNT_LOCKED.defaultValue)}
                />
                <p>
                    {t(INTL_ACCOUNT_LOCKED_MESSAGE.key, INTL_ACCOUNT_LOCKED_MESSAGE.defaultValue)}
                </p>
                <p>{t(INTL_UNLOCK_INSTRUCTIONS.key, INTL_UNLOCK_INSTRUCTIONS.defaultValue)}</p>
                <p className={s.smalltext}>
                    {t(INTL_REQUEST_NEW_EMAIL.key, INTL_REQUEST_NEW_EMAIL.defaultValue)}
                    {props.requestResetPasswordLink}
                </p>
            </div>
        </div>
    );
};

AccountLocked.propTypes = {
    requestResetPasswordLink: PropTypes.element.isRequired,
};

export default AccountLocked;
